export const INDUSTRY_OPTIONS = [
  { value: 407, label: "(גידול דבורים )מכוורות" },
  { value: 3600, label: "אגירת מים, טיפול ואספקה" },
  { value: 5622, label: "אולמות אירועים" },
  { value: 8574, label: "אולפנים להנחלת הלשון העברית למבוגרים" },
  { value: 8550, label: "אוניברסיטאות" },
  { value: 3811, label: "איסוף אשפה ופסולת שאינה מסוכנת" },
  { value: 3812, label: "איסוף פסולת מסוכנת" },
  { value: 5514, label: "אכסניות ושירותי אירוח לנמ\"א" },
  { value: 5512, label: "אכסניות נוער ובתי ספר שדה" },
  { value: 3530, label: "אספקת קיטור ומיזוג אוויר (קירור)" },
  { value: 9603, label: "ארגון הלוויות ושירותים דומים (קבורה אלטרנטיבית)" },
  { value: 8230, label: "ארגון כנסים ותערוכות מקצועיות" },
  { value: 9900, label: "ארגונים וגופים חוץ-מדינתיים" },
  { value: 1312, label: "אריגת טקסטיל" },
  { value: 5520, label: "אתרי מחנאות (קמפינג) וקרוונים, כולל קייטנות" },
  { value: 6312, label: "אתרי שער לאינטרנט" },
  { value: 7120, label: "בדיקות טכניות וניתוח נתונים טכניים" },
  { value: 6511, label: "ביטוח חיים" },
  { value: 6512, label: "ביטוח כללי" },
  { value: 8430, label: "ביטוח לאומי חובה" },
  { value: 6520, label: "ביטוח משנה" },
  { value: 4104, label: "בנייה והרכבה של מבנים מחלקים מוכנים" },
  { value: 3012, label: "בניית כלי שיט לתענוגות ולספורט" },
  { value: 4220, label: "בניית מיזמי תשתית" },
  { value: 3011, label: "בניית ספינות ומבנים צפים" },
  { value: 6411, label: "בנק מרכזי" },
  { value: 8730, label: "בתי אבות לקשישים" },
  { value: 8610, label: "בתי חולים כלליים" },
  { value: 8611, label: "בתי חולים לבריאות הנפש" },
  { value: 8612, label: "בתי חולים סיעודיים והוספיסים" },
  { value: 5510, label: "בתי מלון ובתי הארחה" },
  { value: 8526, label: "בתי ספר בפיקוח משרד התמ\"ת" },
  { value: 8512, label: "בתי ספר יסודיים בפיקוח אחר ומוסדות פטור" },
  { value: 8510, label: "בתי ספר יסודיים בפיקוח ממלכתי" },
  { value: 8511, label: "בתי ספר יסודיים בפיקוח ממלכתי-דתי" },
  { value: 8513, label: "בתי ספר יסודיים לחינוך מיוחד" },
  { value: 8573, label: "בתי ספר לנהיגה" },
  { value: 5212, label: "בתי קירור" },
  { value: 5630, label: "בתי קפה" },
  { value: 112, label: "גידול אורז" },
  { value: 409, label: "גידול בעלי חיים אחרים" },
  { value: 401, label: "גידול בקר ושוורים" },
  { value: 403, label: "גידול גמלים וחיות אחרות ממשפחת הגמליים" },
  { value: 323, label: "גידול דגי נוי במי ים" },
  { value: 324, label: "גידול דגי נוי במים מתוקים" },
  { value: 111, label: "גידול דגנים (פרט לאורז), קטניות וזרעי שמנים" },
  { value: 123, label: "גידול הדרים" },
  { value: 120, label: "גידול זיתים" },
  { value: 405, label: "גידול חזירים" },
  { value: 115, label: "גידול טבק" },
  { value: 116, label: "גידול יבולים סיביים" },
  { value: 119, label: "גידול יבולים עונתיים אחרים ויבולים למספוא" },
  { value: 129, label: "גידול יבולים רב-שנתיים אחרים" },
  { value: 113, label: "גידול ירקות, מלונים (פירות מקשה), שורשים ופקעות" },
  { value: 402, label: "גידול סוסים וחיות אחרות ממשפחת הסוסיים" },
  { value: 406, label: "גידול עופות" },
  { value: 121, label: "גידול ענבים" },
  { value: 125, label: "גידול עצי פרי אחרים, פירות יער ואגוזים" },
  { value: 210, label: "גידול עצים וטיפוחם ופעילויות ייעור אחרות" },
  { value: 126, label: "גידול פירות המשמשים להפקת שמנים" },
  { value: 124, label: "גידול פירות חרצניים ופירות גלעיניים" },
  { value: 122, label: "גידול פירות טרופיים ופירות סוב-טרופיים" },
  { value: 117, label: "גידול פרחים" },
  { value: 404, label: "גידול צאן" },
  { value: 127, label: "גידול צמחים להכנת משקאות" },
  { value: 114, label: "גידול קני סוכר" },
  { value: 128, label: "גידול תבלינים, צמחים ארומטיים וצמחי מרפא" },
  { value: 4103, label: "גיוס כוח אדם לעבודה בבנייה באמצעות חברות ייעודיות" },
  { value: 1313, label: "גימור טקסטיל" },
  { value: 311, label: "דיג במי ים" },
  { value: 312, label: "דיג במים מתוקים" },
  { value: 1811, label: "הדפסה" },
  { value: 5120, label: "הובלה אווירית של מטענים" },
  { value: 5110, label: "הובלה אווירית של נוסעים" },
  { value: 4930, label: "הובלה באמצעות קווי צינורות" },
  { value: 4925, label: "הובלה ברכבלים" },
  { value: 4923, label: "הובלת מטענים בדרכים" },
  { value: 5012, label: "הובלת מטענים בים ובמימי החופים (מים טריטוריאליים)" },
  { value: 5022, label: "הובלת מטענים בנתיבי מים פנים-ארציים" },
  { value: 4912, label: "הובלת מטענים ברכבות משא" },
  { value: 5011, label: "הובלת נוסעים בים ובמימי החופים (מים טריטוריאליים)" },
  { value: 5021, label: "הובלת נוסעים בנתיבי מים פנים-ארציים" },
  { value: 4911, label: "הובלת נוסעים ברכבות בין-עירוניות" },
  { value: 4929, label: "הובלת נוסעים ברכבת עירונית וברכבת פרברים" },
  { value: 4924, label: "הובלת נוסעים לטיולים ולנסיעות מיוחדות באוטובוסים" },
  { value: 5812, label: "הוצאה לאור של מדריכים ורשימות תפוצה" },
  { value: 5811, label: "הוצאה לאור של ספרים" },
  { value: 5813, label: "הוצאה לאור של עיתונים, מגזינים וכתבי עת" },
  { value: 5819, label: "הוצאה לאור של פרסומים אחרים" },
  { value: 5820, label: "הוצאה לאור של תכנה" },
  { value: 6491, label: "החכר מימוני (ליסינג)" },
  { value: 7740, label: "החכרת קניין רוחני ומוצרים דומים, פרט לעבודות המוגנות בזכויות יוצרים" },
  { value: 4312, label: "הכנת אתרים לבנייה" },
  { value: 6920, label: "הנהלת חשבונות" },
  { value: 4212, label: "הנחת מסילות רכבת" },
  { value: 6621, label: "הערכת סיכון ונזק (שמאות ביטוח)" },
  { value: 9103, label: "הפעלת גנים זואולוגיים, גנים בוטניים ושמורות טבע" },
  { value: 9102, label: "הפעלת מוזאונים, אתרים ומבנים היסטוריים" },
  { value: 9312, label: "הפעלת מועדוני ספורט" },
  { value: 9313, label: "הפעלת מתקני כושר ומועדוני כושר" },
  { value: 9101, label: "הפעלת ספריות וארכיונים" },
  { value: 5913, label: "הפצת סרטי קולנוע, סרטי וידאו ותכניות טלוויזיה" },
  { value: 3510, label: "הפקה, תמסורת וחלוקה של חשמל" },
  { value: 9328, label: "הפקת אירועים" },
  { value: 620, label: "הפקת גז טבעי" },
  { value: 892, label: "הפקת כבול" },
  { value: 893, label: "הפקת מלחים" },
  { value: 610, label: "הפקת נפט גולמי" },
  { value: 5911, label: "הפקת סרטי קולנוע, סרטי וידאו ותכניות טלוויזיה" },
  { value: 5920, label: "הקלטת קול והוצאה לאור של מוזיקה" },
  { value: 5914, label: "הקרנת סרטים" },
  { value: 130, label: "הרביית צמחים" },
  { value: 4311, label: "הריסת מבנים" },
  { value: 7710, label: "השכרה והחכרה של כלי רכב מנועיים" },
  { value: 7729, label: "השכרה והחכרה של סוגים אחרים של מוצרים אישיים ומוצרים לבית" },
  { value: 7730, label: "השכרה והחכרה של סוגים אחרים של מיכון, ציוד ורכוש מוחשי" },
  { value: 7721, label: "השכרה והחכרה של ציוד לפעילויות ספורט ולפנאי" },
  { value: 4398, label: "השכרה של ציוד לבנייה או להריסה, כולל מפעיל" },
  { value: 7722, label: "השכרת דיסקים וקלטות וידאו" },
  { value: 3320, label: "התקנה של מכונות וציוד תעשייתיים" },
  { value: 4325, label: "התקנה של מערכות בקרה והתרעה ומערכות איתות" },
  { value: 4327, label: "התקנה של מערכות למיזוג אוויר ומתקני קירור" },
  { value: 4326, label: "התקנה של מערכות מים, תברואה, ביוב, תיעול וגז" },
  { value: 4395, label: "התקנת מבנים מברזל ומפלדה" },
  { value: 4336, label: "התקנת מחיצות גבס" },
  { value: 4332, label: "התקנת מטבחים" },
  { value: 4329, label: "התקנת מעליות ותשתיות בנייה אחרות" },
  { value: 4328, label: "התקנת מערכות חימום (הסקה) ומערכות אנרגיה סולרית" },
  { value: 4323, label: "התקנת מערכות חשמל" },
  { value: 4324, label: "התקנת מערכות תקשורת" },
  { value: 8310, label: "ועדים מקומיים ואגודות שיתופיות" },
  { value: 4338, label: "זגגות" },
  { value: 4526, label: "זגגות רכב ומיגון רכב" },
  { value: 1101, label: "זיקוק וערבוב של אלכוהול" },
  { value: 6420, label: "חברות אחזקה" },
  { value: 151, label: "חברות המגייסות כוח אדם לחקלאות" },
  { value: 7810, label: "חברות השמה" },
  { value: 7830, label: "חברות השמה אחרות (לטווח ארוך)" },
  { value: 7820, label: "חברות להעסקת כוח אדם" },
  { value: 5513, label: "חדרי נופש להשכרה" },
  { value: 8524, label: "חטיבה עליונה בפיקוח אחר" },
  { value: 8522, label: "חטיבה עליונה בפיקוח ממלכתי" },
  { value: 8523, label: "חטיבה עליונה בפיקוח ממלכתי-דתי" },
  { value: 8520, label: "חטיבות ביניים בפיקוח ממלכתי" },
  { value: 8521, label: "חטיבות ביניים בפיקוח ממלכתי-דתי" },
  { value: 8572, label: "חינוך בתחום התרבות" },
  { value: 8576, label: "חינוך מבוגרים, קורסים, הכשרות, השתלמויות ובתי ספר לנמ\"א" },
  { value: 8525, label: "חינוך על-יסודי (חטיבת ביניים וחטיבה עליונה) במסגרת חינוך מיוחד" },
  { value: 8501, label: "חינוך קדם-יסודי (גני ילדים)" },
  { value: 4394, label: "חיפוי גגות" },
  { value: 4335, label: "חיפוי רצפות וקירות בחומרים רכים" },
  { value: 2396, label: "חיתוך, עיצוב וליטוש של אבנים" },
  { value: 810, label: "חציבת אבן, חול וחומר" },
  { value: 321, label: "חקלאות ימית במי ים" },
  { value: 322, label: "חקלאות ימית במים מתוקים" },
  { value: 7320, label: "חקר שווקים וסקרי דעת קהל" },
  { value: 4523, label: "חשמלאות רכב" },
  { value: 1311, label: "טווייה, סלילה ושזירה של חוטי כותנה וסיבי טקסטיל" },
  { value: 1061, label: "טחינת תבואת דגנים וגריסתה" },
  { value: 5224, label: "טיפול אחר במטענים" },
  { value: 3822, label: "טיפול בפסולת מסוכנת וסילוקה" },
  { value: 3821, label: "טיפול בפסולת שאינה מסוכנת וסילוקה" },
  { value: 4102, label: "יזמות בנייה" },
  { value: 6202, label: "ייעוץ בתחום המחשבים וניהול מתקנים ממוחשבים" },
  { value: 6922, label: "ייעוץ מס" },
  { value: 2713, label: "ייצור אביזרים לחלוקה ולבקרה של חשמל" },
  { value: 3091, label: "ייצור אופנועים" },
  { value: 3092, label: "ייצור אופניים וכיסאות גלגלים" },
  { value: 1391, label: "ייצור אריגים סרוגים ואריגי קרושה" },
  { value: 2594, label: "ייצור אריזות ומכלים מפח, זיווד אלקטרוני ומוצרי פח לנמ\"א" },
  { value: 1412, label: "ייצור בגדי ים" },
  { value: 1410, label: "ייצור בגדים (פרט לבגדי פרווה)" },
  { value: 1430, label: "ייצור בגדים סרוגים ובגדי קרושה" },
  { value: 2397, label: "ייצור בטון מוכן ליציקה" },
  { value: 1103, label: "ייצור בירה ומיני שכר, על בסיס לתת" },
  { value: 2398, label: "ייצור בלוקים" },
  { value: 2410, label: "ייצור ברזל ופלדה בסיסיים" },
  { value: 1071, label: "ייצור דברי מאפה" },
  { value: 2040, label: "ייצור דשנים ותרכובות חנקן" },
  { value: 1411, label: "ייצור הלבשה תחתונה" },
  { value: 3520, label: "ייצור ואספקת גז וגזי-דלק (טבעיים וסינתטיים) דרך צינורות ראשיים" },
  { value: 2310, label: "ייצור זכוכית ומוצרים מזכוכית" },
  { value: 1394, label: "ייצור חבלים, חוטים שזורים ורשתות" },
  { value: 2392, label: "ייצור חומרי בנייה מחרס" },
  { value: 2021, label: "ייצור חומרי הדברה וחיטוי לשימוש ביתי ולחקלאות" },
  { value: 2930, label: "ייצור חלקי חילוף ואביזרים לכלי רכב מנועיים" },
  { value: 3511, label: "ייצור חשמל באמצעות אנרגיה מתחדשת" },
  { value: 1102, label: "ייצור יינות" },
  { value: 2731, label: "ייצור כבלי סיבים אופטיים" },
  { value: 2011, label: "ייצור כימיקלים בסיסיים" },
  { value: 2596, label: "ייצור כלי בישול, מבלטים ותבניות ממתכת" },
  { value: 3030, label: "ייצור כלי טיס, חלליות וציוד נלווה" },
  { value: 3220, label: "ייצור כלי נגינה" },
  { value: 2818, label: "ייצור כלי עבודה ידניים ממונעים" },
  { value: 2593, label: "ייצור כלי עבודה ידניים, ציוד מכני כללי וסכו\"ם" },
  { value: 2910, label: "ייצור כלי רכב מנועיים" },
  { value: 3099, label: "ייצור כלי תחבורה והובלה אחרים לנמ\"א" },
  { value: 2230, label: "ייצור לוחות וצינורות מפלסטיק" },
  { value: 1621, label: "ייצור לוחות פורניר ופנלים מעץ" },
  { value: 2680, label: "ייצור מדיה מגנטית ואופטית" },
  { value: 2395, label: "ייצור מוצרי בטון, צמנט וטיח" },
  { value: 2219, label: "ייצור מוצרי גומי אחרים" },
  { value: 1050, label: "ייצור מוצרי חלב" },
  { value: 1200, label: "ייצור מוצרי טבק" },
  { value: 1079, label: "ייצור מוצרי מזון אחרים, לנמ\"א" },
  { value: 2599, label: "ייצור מוצרי מתכת לנמ\"א" },
  { value: 1920, label: "ייצור מוצרי נפט מזוקק" },
  { value: 1629, label: "ייצור מוצרי עץ אחרים; ייצור מוצרי שעם, קש וחומרים לקליעה" },
  { value: 2640, label: "ייצור מוצרי צריכה אלקטרוניים" },
  { value: 2391, label: "ייצור מוצרי קרמיקה (חסיני אש)" },
  { value: 2399, label: "ייצור מוצרים אחרים ממינרלים אל-מתכתיים, לנמ\"א" },
  { value: 1709, label: "ייצור מוצרים אחרים מנייר ומקרטון" },
  { value: 2393, label: "ייצור מוצרים אחרים מקרמיקה ומחרסינה" },
  { value: 2260, label: "ייצור מוצרים מפלסטיק למטבח, לשולחן ולבית" },
  { value: 2280, label: "ייצור מוצרים מפלסטיק לנמ\"א" },
  { value: 2270, label: "ייצור מוצרים מפלסטיק לשימושים טכניים, חקלאיים ותעשייתיים" },
  { value: 2250, label: "ייצור מוצרים מפלסטיק משוריין" },
  { value: 1420, label: "ייצור מוצרים מפרווה (כולל בגדי פרווה)" },
  { value: 1910, label: "ייצור מוצרים מתנורי קוק" },
  { value: 1512, label: "ייצור מזוודות, תיקים ומוצרים דומים (פרט לבגדים ולנעליים), אוכפים ורתמו" },
  { value: 1075, label: "ייצור מזון מוכן" },
  { value: 1080, label: "ייצור מזון מוכן לבעלי חיים" },
  { value: 2513, label: "ייצור מחוללי קיטור, פרט לדודי מים למערכות חימום מרכזיות" },
  { value: 2621, label: "ייצור מחשבים וציוד היקפי" },
  { value: 2822, label: "ייצור מכונות וכלי עבודה ממונעים לעיצוב מתכות" },
  { value: 2819, label: "ייצור מכונות וציוד אחרים לשימוש כללי" },
  { value: 2817, label: "ייצור מכונות וציוד למשרד (פרט למחשבים ולציוד היקפי)" },
  { value: 2829, label: "ייצור מכונות ייעודיות אחרות" },
  { value: 2821, label: "ייצור מכונות לחקלאות ולייעור" },
  { value: 2823, label: "ייצור מכונות לטיפול במתכות (מטלורגיה)" },
  { value: 2826, label: "ייצור מכונות לייצור טקסטיל ומוצריו ולטיפול בעורות" },
  { value: 2824, label: "ייצור מכונות לכרייה, לחציבה ולבנייה" },
  { value: 2825, label: "ייצור מכונות לעיבוד מזון, משקאות וטבק" },
  { value: 1623, label: "ייצור מכלי עץ" },
  { value: 2240, label: "ייצור מכלים ובקבוקים מפלסטיק" },
  { value: 2512, label: "ייצור מכלים וכלי אגירה ממתכת" },
  { value: 2670, label: "ייצור מכשור אופטי וציוד צילום" },
  { value: 2750, label: "ייצור מכשירי חשמל ביתיים" },
  { value: 2651, label: "ייצור מכשירי מדידה, בדיקה, ניווט ובקרה" },
  { value: 2811, label: "ייצור מנועים וטורבינות, פרט למנועים לכלי טיס, לכלי רכב מנועיים ולאופנו" },
  { value: 2711, label: "ייצור מנועים חשמליים" },
  { value: 2814, label: "ייצור מסבים, ממסרות וציוד הנעה" },
  { value: 1070, label: "ייצור מצות" },
  { value: 1074, label: "ייצור מקרוני, אטריות, קוסקוס ומזונות עמילניים דומים" },
  { value: 2920, label: "ייצור מרכבים לכלי רכב מנועיים; ייצור נגררים" },
  { value: 2813, label: "ייצור משאבות, מדחסים, ברזים ושסתומים אחרים" },
  { value: 3240, label: "ייצור משחקים וצעצועים" },
  { value: 1104, label: "ייצור משקאות קלים; מים מינרליים וסוגים אחרים של מים בבקבוקים" },
  { value: 2420, label: "ייצור מתכות יקרות בסיסיות ומתכות אל-ברזליות אחרות" },
  { value: 2733, label: "ייצור מתקני חיווט" },
  { value: 1702, label: "ייצור נייר וקרטון גליים וייצור מכלים מנייר ומקרטון" },
  { value: 1520, label: "ייצור נעליים" },
  { value: 2520, label: "ייצור נשק ותחמושת" },
  { value: 2070, label: "ייצור סבון ואבקות כביסה, חומרי ניקוי והברקה, ותכשירי ניקוי ותמרוקים" },
  { value: 2732, label: "ייצור סוגים אחרים של חוטים וכבלים חשמליים ואלקטרוניים" },
  { value: 1399, label: "ייצור סוגים אחרים של טקסטיל, לנמ\"א" },
  { value: 1072, label: "ייצור סוכר" },
  { value: 2720, label: "ייצור סוללות ומצברים" },
  { value: 2030, label: "ייצור סיבים סינתטיים" },
  { value: 1701, label: "ייצור עיסת עץ, נייר ונייר קרטון" },
  { value: 1062, label: "ייצור עמילן ומוצריו" },
  { value: 2050, label: "ייצור פלסטיק וגומי סינתטי בצורתם הראשונית (תעשייה פטרוכימית)" },
  { value: 1392, label: "ייצור פריטי טקסטיל מוכנים, פרט לפריטי לבוש" },
  { value: 2060, label: "ייצור צבעים, לכות וחומרי ציפוי דומים, דיו להדפסה ושרף" },
  { value: 2660, label: "ייצור ציוד הקרנה, מכשור אלקטרוני רפואי, מכשור אלקטרוני טיפולי ומכשור ר" },
  { value: 2816, label: "ייצור ציוד הרמה, שינוע, פריקה וטעינה" },
  { value: 2790, label: "ייצור ציוד חשמלי אחר" },
  { value: 2812, label: "ייצור ציוד למערכות הידראוליות ופנאומטיות" },
  { value: 3230, label: "ייצור ציוד ספורט" },
  { value: 3250, label: "ייצור ציוד רפואי, דנטלי ואורתופדי" },
  { value: 2740, label: "ייצור ציוד תאורה חשמלית" },
  { value: 2630, label: "ייצור ציוד תקשורת" },
  { value: 2211, label: "ייצור צמיגים ואבובים; שיקום צמיגים פגומים" },
  { value: 2394, label: "ייצור צמנט, סיד וטיח" },
  { value: 3020, label: "ייצור קטרי רכבת, קרונות וכלי תחבורה והובלה אחרים שנעים על מסילות רכבת" },
  { value: 1073, label: "ייצור קקאו, שוקולד וממתקים" },
  { value: 3100, label: "ייצור רהיטים" },
  { value: 3040, label: "ייצור רכבי קרב צבאיים" },
  { value: 2610, label: "ייצור רכיבים ולוחות אלקטרוניים" },
  { value: 2595, label: "ייצור רשתות, כבלים, חוטים ותיל, ממתכת ברזלית ואל-ברזלית" },
  { value: 1040, label: "ייצור שומנים ושמנים מן החי ומן הצומח" },
  { value: 1393, label: "ייצור שטיחים ומרבדים" },
  { value: 2511, label: "ייצור שלדי מתכת" },
  { value: 2712, label: "ייצור שנאים" },
  { value: 2652, label: "ייצור שעונים" },
  { value: 2220, label: "ייצור שרוולים ויריעות מפלסטיק" },
  { value: 3211, label: "ייצור תכשיטים יקרים ופריטים דומים" },
  { value: 3212, label: "ייצור תכשיטים מלאכותיים ופריטים דומים" },
  { value: 2815, label: "ייצור תנורים מקובעים, כבשנים, מבערים ומערכות אנרגיה סולרית" },
  { value: 2100, label: "ייצור תרופות קונבנציונליות ותרופות הומאופתיות לבני אדם ולשימוש וטרינרי" },
  { value: 2431, label: "יציקות ברזל ופלדה" },
  { value: 2432, label: "יציקות מתכות אל-ברזליות" },
  { value: 9000, label: "יצירה, אמנות ובידור" },
  { value: 8560, label: "ישיבות ובתי ספר תורניים" },
  { value: 894, label: "כריית יהלומים" },
  { value: 891, label: "כריית מינרלים לכימיקלים ולדשנים" },
  { value: 4210, label: "כריית מנהרות" },
  { value: 729, label: "כריית סוגים אחרים של עפרות מתכת אל-ברזליות" },
  { value: 721, label: "כריית עפרות אורניום ועפרות תוריום" },
  { value: 710, label: "כריית עפרות ברזל" },
  { value: 510, label: "כריית פחם אבן" },
  { value: 520, label: "כריית פחם חום" },
  { value: 220, label: "כריתת עצים" },
  { value: 230, label: "ליקוט תוצרי יער, פרט לעצים" },
  { value: 8623, label: "לשכות בריאות, תחנות לבריאות המשפחה והקהילה, תחנות למניעת מחלות" },
  { value: 8790, label: "מגורים טיפוליים אחרים" },
  { value: 8720, label: "מגורים טיפוליים למוגבלים שכלית התפתחותית" },
  { value: 8722, label: "מגורים טיפוליים לסובלים מהתמכרויות" },
  { value: 8721, label: "מגורים טיפוליים לסובלים ממחלות נפש" },
  { value: 8710, label: "מגורים טיפוליים סיעודיים" },
  { value: 5225, label: "מגרשי חניה" },
  { value: 8532, label: "מוסדות חינוך על-תיכוניים (לא אקדמיים) להכשרת טכנאים והנדסאים" },
  { value: 8531, label: "מוסדות חינוך על-תיכוניים (לא אקדמיים) להכשרת מורים" },
  { value: 8533, label: "מוסדות חינוך על-תיכוניים אחרים (לא אקדמיים)" },
  { value: 8450, label: "מוסדות לאומיים" },
  { value: 4521, label: "מוסכים כלליים לתיקון ולתחזוקה של כלי רכב מנועיים" },
  { value: 8220, label: "מוקדי שירות טלפוני" },
  { value: 8575, label: "מורים פרטיים" },
  { value: 3830, label: "מחזור (והשבה) של חומרים" },
  { value: 5211, label: "מחסני ערובה" },
  { value: 5210, label: "מחסנים כלליים" },
  { value: 7210, label: "מחקר ופיתוח בהנדסה ובמדעי הטבע" },
  { value: 7220, label: "מחקר ופיתוח במדעי החברה ובמדעי הרוח" },
  { value: 8312, label: "מינהל מקומי בתחומי החברה והרווחה" },
  { value: 8323, label: "מינהל מקומי בתחומי הסדר הציבורי והביטחון" },
  { value: 8313, label: "מינהל מקומי בתחומי התשתיות" },
  { value: 8311, label: "מינהל מקומי כללי" },
  { value: 8390, label: "מינהל מקומי לנמ\"א" },
  { value: 8411, label: "מינהל ציבורי כללי" },
  { value: 8414, label: "מינהל ציבורי לנמ\"א" },
  { value: 8530, label: "מכינות קדם-אקדמיות" },
  { value: 4770, label: "מכירה קמעונית בחנויות המתמחות בביגוד ובאביזרי ביגוד נלווים" },
  { value: 4726, label: "מכירה קמעונית בחנויות המתמחות בבשר, בעופות, בדגים ובמוצריהם" },
  { value: 4727, label: "מכירה קמעונית בחנויות המתמחות בדברי מאפה" },
  { value: 4729, label: "מכירה קמעונית בחנויות המתמחות בדברי מתיקה" },
  { value: 4773, label: "מכירה קמעונית בחנויות המתמחות בהנעלה" },
  { value: 4775, label: "מכירה קמעונית בחנויות המתמחות בחפצי אמנות ובמזכרות" },
  { value: 4751, label: "מכירה קמעונית בחנויות המתמחות בטקסטיל" },
  { value: 4756, label: "מכירה קמעונית בחנויות המתמחות בכלי בית" },
  { value: 4757, label: "מכירה קמעונית בחנויות המתמחות בכלי נגינה" },
  { value: 4752, label: "מכירה קמעונית בחנויות המתמחות בכלים ממתכת, בצבעים ובזכוכית" },
  { value: 4762, label: "מכירה קמעונית בחנויות המתמחות במוזיקה ובסרטים על גבי מדיה" },
  { value: 4755, label: "מכירה קמעונית בחנויות המתמחות במוצרי חשמל וגז ביתיים" },
  { value: 4723, label: "מכירה קמעונית בחנויות המתמחות במוצרי טבק" },
  { value: 4741, label: "מכירה קמעונית בחנויות המתמחות במחשבים, בציוד היקפי, בתכנה ובציוד תקשור" },
  { value: 4764, label: "מכירה קמעונית בחנויות המתמחות במשחקים ובצעצועים" },
  { value: 4722, label: "מכירה קמעונית בחנויות המתמחות במשקאות" },
  { value: 4778, label: "מכירה קמעונית בחנויות המתמחות בנשק" },
  { value: 4761, label: "מכירה קמעונית בחנויות המתמחות בספרים, בעיתונים בציוד משרדי ובצורכי כתי" },
  { value: 4725, label: "מכירה קמעונית בחנויות המתמחות בפירות ובירקות" },
  { value: 4742, label: "מכירה קמעונית בחנויות המתמחות בציוד אודיו ווידאו" },
  { value: 4776, label: "מכירה קמעונית בחנויות המתמחות בציוד לצילום ובצורכי צילום, במכשור מדויק" },
  { value: 4763, label: "מכירה קמעונית בחנויות המתמחות בציוד ספורט ובאופניים" },
  { value: 4754, label: "מכירה קמעונית בחנויות המתמחות ברהיטים" },
  { value: 4753, label: "מכירה קמעונית בחנויות המתמחות בשטיחים, במרבדים ובחיפויי קיר ורצפה" },
  { value: 4777, label: "מכירה קמעונית בחנויות המתמחות בשעונים ובתכשיטים" },
  { value: 4772, label: "מכירה קמעונית בחנויות המתמחות בתרופות ובמוצרים רפואיים, במוצרים קוסמטי" },
  { value: 4711, label: "מכירה קמעונית בחנויות לממכר כללי המתמחות במוצרי מזון, במשקאות ובטבק" },
  { value: 4724, label: "מכירה קמעונית בחנויות מכולת ובמינימרקטים" },
  { value: 4791, label: "מכירה קמעונית דרך הזמנות בדואר, באינטרנט ובאמצעים אחרים" },
  { value: 4758, label: "מכירה קמעונית מעורבת של רהיטים, של מכשירים ושל ציוד למשק הבית לנמ\"א" },
  { value: 4533, label: "מכירה קמעונית של אביזרים לכלי רכב מנועיים" },
  { value: 4730, label: "מכירה קמעונית של דלק למכוניות (תחנות דלק)" },
  { value: 4532, label: "מכירה קמעונית של חלקי חילוף לכלי רכב מנועיים" },
  { value: 4782, label: "מכירה קמעונית של טקסטיל, ביגוד והנעלה בדוכנים ובשווקים" },
  { value: 4728, label: "מכירה קמעונית של מוצרי מזון לנמ\"א" },
  { value: 4771, label: "מכירה קמעונית של מוצרי עור; מכירה קמעונית מעורבת של מוצרי טקסטיל" },
  { value: 4781, label: "מכירה קמעונית של מזון, משקאות ומוצרי טבק בדוכנים ובשווקים" },
  { value: 4789, label: "מכירה קמעונית של סחורות אחרות בדוכנים ובשווקים" },
  { value: 4779, label: "מכירה קמעונית של סחורות אחרות לנמ\"א" },
  { value: 4774, label: "מכירה קמעונית של סחורות משומשות" },
  { value: 8542, label: "מכללות אקדמיות אחרות" },
  { value: 8541, label: "מכללות אקדמיות להכשרת מורים" },
  { value: 5511, label: "מלונות דירות ומלונות דרכים" },
  { value: 5213, label: "ממגורות" },
  { value: 4331, label: "מסגרות ברזל, התקנת עבודות אלומיניום" },
  { value: 2592, label: "מסגריות, עיבוד מכני ועיבוד שבבי" },
  { value: 5226, label: "מסופי מטען" },
  { value: 4511, label: "מסחר ותיווך בכלי רכב מנועיים חדשים" },
  { value: 4512, label: "מסחר ותיווך בכלי רכב מנועיים משומשים" },
  { value: 4641, label: "מסחר סיטוני בביגוד" },
  { value: 4633, label: "מסחר סיטוני בביצים, בבשר, בעופות, בדגים ובמוצריהם" },
  { value: 4622, label: "מסחר סיטוני בבעלי חיים" },
  { value: 4661, label: "מסחר סיטוני בדלקים מוצקים, נוזליים וגזיים ובמוצרים נלווים" },
  { value: 4642, label: "מסחר סיטוני בהנעלה" },
  { value: 4665, label: "מסחר סיטוני בחומרי בנייה ובצורכי שרברבות" },
  { value: 4621, label: "מסחר סיטוני בחומרי גלם חקלאיים" },
  { value: 4644, label: "מסחר סיטוני בחומרי ניקוי ובתמרוקים" },
  { value: 4632, label: "מסחר סיטוני בחלב ובמוצריו" },
  { value: 4531, label: "מסחר סיטוני בחלקי חילוף ובאביזרים לכלי רכב מנועיים" },
  { value: 4636, label: "מסחר סיטוני בטבק ובמוצריו" },
  { value: 4640, label: "מסחר סיטוני בטקסטיל" },
  { value: 4670, label: "מסחר סיטוני ביהלומים" },
  { value: 4666, label: "מסחר סיטוני בכימיקלים" },
  { value: 4646, label: "מסחר סיטוני במוצרי חשמל וגז ביתיים" },
  { value: 4634, label: "מסחר סיטוני במוצרי מזון" },
  { value: 4651, label: "מסחר סיטוני במחשבים, בציוד היקפי ובתכנה" },
  { value: 4658, label: "מסחר סיטוני במכונות ובציוד ובחלקיהם לנמ\"א" },
  { value: 4657, label: "מסחר סיטוני במכונות ובציוד לבנייה ולעבודות עפר ובחלקיהם" },
  { value: 4655, label: "מסחר סיטוני במכונות ובציוד לתעשייה ובחלקיהם" },
  { value: 4656, label: "מסחר סיטוני במכונות ובציוד משרדיים ובחלקיהם" },
  { value: 4653, label: "מסחר סיטוני במכונות, בציוד ובאספקה לחקלאות" },
  { value: 4635, label: "מסחר סיטוני במשקאות קלים ובמשקאות אלכוהוליים" },
  { value: 4662, label: "מסחר סיטוני במתכות ובעפרות מתכת" },
  { value: 4669, label: "מסחר סיטוני בנייר, בקרטון ובמוצריהם, בפסולת, בגרוטאות ובמוצרים דומים ל" },
  { value: 4648, label: "מסחר סיטוני בספרים, בכתבי עת, בעיתונים, בצעצועים ובמשחקי מחשב" },
  { value: 4664, label: "מסחר סיטוני בעץ" },
  { value: 4631, label: "מסחר סיטוני בפירות ובירקות" },
  { value: 4667, label: "מסחר סיטוני בפלסטיק ובגומי" },
  { value: 4623, label: "מסחר סיטוני בפרחים ובצמחים" },
  { value: 4654, label: "מסחר סיטוני בצורכי חשמל" },
  { value: 4649, label: "מסחר סיטוני בציוד ספורט" },
  { value: 4652, label: "מסחר סיטוני בציוד תקשורת וברכיבים אלקטרוניים" },
  { value: 4643, label: "מסחר סיטוני ברהיטים, במוצרי אופטיקה, בכלי בית וכלי מטבח ובטובין למשק ה" },
  { value: 4647, label: "מסחר סיטוני בתכשיטים, בשעונים ובחפצי חן" },
  { value: 4645, label: "מסחר סיטוני בתרופות ובמוצרים רפואיים נלווים" },
  { value: 4540, label: "מסחר סיטוני וקמעוני באופנועים, בחלקי חילוף ובאביזרים נלווים; תחזוקה ות" },
  { value: 4690, label: "מסחר סיטוני כללי ובסחורות לנמ\"א" },
  { value: 4610, label: "מסחר סיטוני על בסיס עמלה או חוזה" },
  { value: 5610, label: "מסעדות" },
  { value: 7201, label: "מרכזי מחקר ופיתוח" },
  { value: 6203, label: "מרכזי מחקר ופיתוח תכנה" },
  { value: 9440, label: "מרכזים קהילתיים (מתנ\"סים)" },
  { value: 8621, label: "מרפאות ומכוני רפואה פרטיים" },
  { value: 8620, label: "מרפאות ציבוריות" },
  { value: 1011, label: "משחטות ובתי מטבחיים" },
  { value: 8891, label: "משפחתונים ופעוטונים" },
  { value: 9810, label: "משקי בית המייצרים מגוון טובין לשימוש עצמי" },
  { value: 9820, label: "משקי בית המספקים מגוון שירותים לשימוש עצמי" },
  { value: 9700, label: "משקי בית כמקומות תעסוקה (לעובדי משק בית)" },
  { value: 408, label: "משקים מעורבים בתחום גידול בעלי חיים" },
  { value: 118, label: "משקים מעורבים בתחום גידולים צמחיים" },
  { value: 9311, label: "מתקני ספורט" },
  { value: 4330, label: "נגרות בניין" },
  { value: 150, label: "ניהול משק חקלאי מעורב" },
  { value: 8421, label: "ניהול ענייני החוץ" },
  { value: 6630, label: "ניהול קרנות" },
  { value: 6611, label: "ניהול שווקים פיננסיים" },
  { value: 1610, label: "ניסור עץ ושיופו" },
  { value: 899, label: "סוגים אחרים של כרייה וחציבה, לנמ\"א" },
  { value: 4719, label: "סוגים אחרים של מכירה קמעונית בחנויות לממכר כללי" },
  { value: 4799, label: "סוגים אחרים של מכירה קמעונית, שלא במסגרת חנויות, דוכנים או שווקים" },
  { value: 6492, label: "סוגים אחרים של מתן אשראי" },
  { value: 9329, label: "סוגים אחרים של פעילויות בילוי ופנאי, לנמ\"א" },
  { value: 7490, label: "סוגים אחרים של שירותים מקצועיים, מדעיים וטכניים, לנמ\"א" },
  { value: 6419, label: "סוגים אחרים של תיווך מוניטרי" },
  { value: 5229, label: "סוכנויות אניות וחברות תעופה" },
  { value: 6391, label: "סוכנויות ידיעות" },
  { value: 4396, label: "עבודות איטום ובידוד" },
  { value: 4392, label: "עבודות בטון" },
  { value: 4393, label: "עבודות בנייה בלבנים ובאבן" },
  { value: 4397, label: "עבודות גימור חיצוני לנמ\"א" },
  { value: 4290, label: "עבודות הנדסה אזרחית אחרות" },
  { value: 4333, label: "עבודות טיח" },
  { value: 240, label: "עבודות עזר בתחום הייעור" },
  { value: 161, label: "עבודות עזר לגידול יבולים" },
  { value: 4211, label: "עבודות עפר, סלילת כבישים, בניית גשרים ומסלולי טיסה" },
  { value: 4213, label: "עבודות שטח, צביעה וסימון" },
  { value: 163, label: "עבודות שמתבצעות לאחר הקציר, הקטיף, הבציר וכד'" },
  { value: 1010, label: "עיבוד בשר ושימורו" },
  { value: 1020, label: "עיבוד דגים, סרטנים ורכיכות ושימורם" },
  { value: 164, label: "עיבוד זרעים להרביה" },
  { value: 3400, label: "עיבוד יהלומים" },
  { value: 2591, label: "עיבוד מתכות וציפוין, חישול, לחיצה, הטבעה וגלגול של מתכות; מטלורגיית אב" },
  { value: 6311, label: "עיבוד נתונים, אחסון ושירותים נלווים" },
  { value: 1511, label: "עיבוד עורות ועיבוד פרוות וצביעתן" },
  { value: 1030, label: "עיבוד פירות וירקות ושימורם" },
  { value: 7411, label: "עיצוב אפנה" },
  { value: 7412, label: "עיצוב פנים ועיצוב תעשייתי" },
  { value: 9602, label: "עיצוב שער וטיפולי יופי אחרים" },
  { value: 6612, label: "עמילות בניירות ערך ובסחורות" },
  { value: 5227, label: "עמילות מכס ושילוח סחורות" },
  { value: 3290, label: "ענפי ייצור אחרים לנמ\"א" },
  { value: 5912, label: "פוסט-פרודקשן של סרטי קולנוע, סרטי וידאו ותכניות טלוויזיה" },
  { value: 4522, label: "פחחות וצבעות רכב" },
  { value: 8413, label: "פיקוח על הפעילות העסקית ושיפור דרכי התנהלותה" },
  { value: 8412, label: "פיקוח על מתן שירותי בריאות, חינוך, תרבות ושירותים חברתיים אחרים, פרט ל" },
  { value: 6810, label: "פעילויות בנדל\"ן בבעלות עצמית" },
  { value: 6820, label: "פעילויות בנדל\"ן על בסיס עמלה או חוזה" },
  { value: 9200, label: "פעילויות הימורים והתערבויות" },
  { value: 9319, label: "פעילויות ספורט אחרות" },
  { value: 6629, label: "פעילויות עזר אחרות הנלוות לביטוח ולקרנות פנסיה" },
  { value: 6619, label: "פעילויות עזר אחרות הנלוות לשירותים פיננסיים" },
  { value: 410, label: "פעילויות עזר לגידול בעלי חיים" },
  { value: 910, label: "פעילויות עזר להפקת נפט גולמי וגז טבעי" },
  { value: 990, label: "פעילויות עזר לסוגים אחרים של כרייה וחציבה" },
  { value: 8422, label: "פעילויות צבא והגנה" },
  { value: 9420, label: "פעילויות של איגודי עובדים" },
  { value: 9499, label: "פעילויות של ארגוני חברים אחרים, לנמ\"א" },
  { value: 9412, label: "פעילויות של ארגוני חברים מקצועיים" },
  { value: 9411, label: "פעילויות של ארגוני חברים עסקיים" },
  { value: 9492, label: "פעילויות של ארגונים פוליטיים" },
  { value: 7912, label: "פעילויות של מארגני טיולים (סיטונאות בתיירות)" },
  { value: 8291, label: "פעילויות של סוכנויות גבייה וסוכנויות מידע לאשראי" },
  { value: 7911, label: "פעילויות של סוכנויות נסיעות" },
  { value: 6622, label: "פעילויות של סוכני ביטוח" },
  { value: 7310, label: "פרסום" },
  { value: 9321, label: "פרקי שעשועים" },
  { value: 4337, label: "צבעות" },
  { value: 420, label: "ציד, לכידה ופעילויות נלוות" },
  { value: 4101, label: "קבלנות בניין" },
  { value: 5629, label: "קבלני מזון ושירותי מזון אחרים" },
  { value: 8571, label: "קורסי ספורט ופנאי" },
  { value: 5611, label: "קיוסקים, דוכנים ומזנונים" },
  { value: 6430, label: "קרנות נאמנות וישויות פיננסיות דומות" },
  { value: 6530, label: "קרנות פנסיה וקופות גמל" },
  { value: 6921, label: "ראיית חשבון" },
  { value: 4527, label: "ריפוד רכב ותיקון כלי רכב מנועיים לנמ\"א" },
  { value: 4334, label: "ריצוף וחיפוי קירות בחומרים קשים" },
  { value: 8622, label: "רפואת שיניים" },
  { value: 6020, label: "שידור תכניות טלוויזיה" },
  { value: 6010, label: "שידורי רדיו" },
  { value: 4105, label: "שיפוץ מבנים ועבודות בניין לנמ\"א" },
  { value: 7110, label: "שירותי אדריכלות" },
  { value: 4921, label: "שירותי אוטובוסים בקווים קבועים" },
  { value: 5590, label: "שירותי אירוח אחרים" },
  { value: 8292, label: "שירותי אריזה" },
  { value: 3700, label: "שירותי ביוב" },
  { value: 5320, label: "שירותי בלדרות" },
  { value: 8690, label: "שירותי בריאות אחרים" },
  { value: 8130, label: "שירותי גינון ותחזוקה" },
  { value: 7410, label: "שירותי גרפיקה" },
  { value: 5310, label: "שירותי דואר" },
  { value: 5631, label: "שירותי הגשת משקאות אלכוהוליים" },
  { value: 9434, label: "שירותי הדת הדרוזית ושירותי דת לנמ\"א" },
  { value: 9431, label: "שירותי הדת היהודית" },
  { value: 9432, label: "שירותי הדת המוסלמית" },
  { value: 9433, label: "שירותי הדת הנוצרית" },
  { value: 7990, label: "שירותי הזמנות ושירותים נלווים אחרים" },
  { value: 7111, label: "שירותי הנדסה ושירותי ייעוץ טכני-הנדסי" },
  { value: 5621, label: "שירותי הסעדה פרטיים" },
  { value: 8030, label: "שירותי חקירה" },
  { value: 3900, label: "שירותי טיהור ושירותים אחרים לטיפול בפסולת" },
  { value: 7020, label: "שירותי ייעוץ ניהולי" },
  { value: 9601, label: "שירותי כביסה וניקוי יבש של מוצרי טקסטיל ושל פרווה" },
  { value: 4926, label: "שירותי מוניות בקווים קבועים" },
  { value: 4928, label: "שירותי מוניות בשירות מיוחד" },
  { value: 4927, label: "שירותי מוניות טיול ותיור" },
  { value: 8820, label: "שירותי מטפלי בית" },
  { value: 6399, label: "שירותי מידע אחרים, לנמ\"א" },
  { value: 8020, label: "שירותי מערכות אבטחה" },
  { value: 7010, label: "שירותי משרדים ראשיים" },
  { value: 8129, label: "שירותי ניקיון אחרים" },
  { value: 8121, label: "שירותי ניקיון כללי לבניינים" },
  { value: 4525, label: "שירותי סיכה ורחיצה" },
  { value: 5223, label: "שירותי עזר להובלה אווירית (שירותים של שדות תעופה)" },
  { value: 5222, label: "שירותי עזר להובלה ימית (שירותים של נמלי ים)" },
  { value: 5228, label: "שירותי עזר להובלה לנמ\"א" },
  { value: 8691, label: "שירותי עזרה ראשונה" },
  { value: 7420, label: "שירותי צילום" },
  { value: 8890, label: "שירותי רווחה וסעד אחרים ללא מגורים" },
  { value: 8810, label: "שירותי רווחה וסעד ללא מגורים לקשישים ולנכים" },
  { value: 6821, label: "שירותי שמאות בתחום הנדל\"ן" },
  { value: 8010, label: "שירותי שמירה ואבטחה" },
  { value: 8299, label: "שירותי תמיכה אחרים לעסקים, לנמ\"א" },
  { value: 8580, label: "שירותי תמיכה בתחום החינוך" },
  { value: 8219, label: "שירותי תמיכה מקצועיים למשרדים, כולל צילום והכנה של מסמכים" },
  { value: 8110, label: "שירותי תמיכה משולבים למתקנים" },
  { value: 6190, label: "שירותי תקשורת אחרים" },
  { value: 6120, label: "שירותי תקשורת אלחוטית" },
  { value: 6130, label: "שירותי תקשורת לוויינים" },
  { value: 6110, label: "שירותי תקשורת קווית" },
  { value: 6209, label: "שירותים אחרים בתחום טכנולוגיית המידע והמחשבים" },
  { value: 9609, label: "שירותים אישיים אחרים, לנמ\"א" },
  { value: 7500, label: "שירותים וטרינריים" },
  { value: 8211, label: "שירותים משולבים בתחום הניהול המשרדי" },
  { value: 6910, label: "שירותים משפטיים" },
  { value: 1812, label: "שירותים נלווים להדפסה" },
  { value: 6499, label: "שירותים פיננסיים אחרים, פרט לביטוח ולקרנות פנסיה, לנמ\"א" },
  { value: 8692, label: "שירותים פסיכולוגיים" },
  { value: 1820, label: "שכפול חומר תקשורתי מוקלט" },
  { value: 8543, label: "שלוחות של אוניברסיטאות מחו\"ל" },
  { value: 8423, label: "שמירה על הסדר הציבורי ועל ביטחון הציבור" },
  { value: 4671, label: "תיווך ביהלומים" },
  { value: 4524, label: "תיקון ומכירה של צמיגים ואבובים" },
  { value: 3315, label: "תיקון כלי תחבורה והובלה, פרט לכלי רכב מנועיים ולאופנועים" },
  { value: 3311, label: "תיקון מוצרי מתכת בהרכבה" },
  { value: 9523, label: "תיקון מוצרי עור והנעלה" },
  { value: 9521, label: "תיקון מוצרי צריכה אלקטרוניים" },
  { value: 9511, label: "תיקון מחשבים וציוד היקפי" },
  { value: 3312, label: "תיקון מכונות" },
  { value: 9522, label: "תיקון מכשירי חשמל ביתיים וציוד לגינה ולבית" },
  { value: 3319, label: "תיקון סוגים אחרים של מכונות וציוד" },
  { value: 9529, label: "תיקון סוגים אחרים של ציוד אישי וציוד לבית" },
  { value: 3314, label: "תיקון ציוד חשמלי" },
  { value: 9512, label: "תיקון ציוד תקשורת" },
  { value: 9524, label: "תיקון רהיטים ואביזרים לבית" },
  { value: 3313, label: "תיקון של ציוד אלקטרוני, אופטי ורפואי" },
  { value: 6201, label: "תכנות מחשבים" },
  { value: 2080, label: "תעשיית מוצרים כימיקליים אחרים, לנמ\"א" },
  { value: 1622, label: "תעשיית נגרות בניין" },
];
export default INDUSTRY_OPTIONS;